import { CustomOrderType } from '../../carts/CustomOrderType';
import { DeleteCartResult } from '@spa/lib/graphql/cart/deleteCart';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartDeleteCartRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
}

export const apiCartDeleteCartRequestedType = 'api/cart/deleteCart--requested';
export const apiCartDeleteCartRequested = createAction<ApiCartDeleteCartRequestedPayload>(
  apiCartDeleteCartRequestedType
);

export type ApiCartDeleteCartRequestedAction = ReturnType<typeof apiCartDeleteCartRequested>;

export interface ApiCartDeleteCartSucceededPayload {
  readonly cartId: string;
  readonly result: DeleteCartResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartDeleteCartSucceededType = 'api/cart/deleteCart--succeeded';

export const apiCartDeleteCartSucceeded = createAction<ApiCartDeleteCartSucceededPayload>(
  apiCartDeleteCartSucceededType
);

export type ApiCartDeleteCartSucceededAction = ReturnType<typeof apiCartDeleteCartSucceeded>;

export interface ApiCartDeleteCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartDeleteCartFailedType = 'api/cart/deleteCart--failed';
export const apiCartDeleteCartFailed = createAction<ApiCartDeleteCartFailedPayload>(
  apiCartDeleteCartFailedType
);
export type ApiCartDeleteCartFailedAction = ReturnType<typeof apiCartDeleteCartFailed>;
